<template>
  <!-- 诊断页面 -->
  <div class="diagnosis">
    <div class="outer-border">
      <div class="b-title title-border-bottom">诊断页面</div>
      <div class="content-two">
        <el-form :model="form" status-icon ref="form" label-width="90px">
          <el-form-item label="基本信息:">
            <table class="table">
              <tr>
                <td class="table-title">姓名</td>
                <td>{{ ya.name }}</td>
                <td class="table-title">性别</td>
                <td>{{ ya.sex }}</td>
                <td class="table-title">年龄</td>
                <td>{{ ya.age }}</td>
              </tr>
              <tr>
                <td class="table-title">药物过敏史</td>
                <td colspan="10" v-if="ya.sex == '女'">
                  {{ jwyws(ya.medicineIrritabilityHistory, "medicine") }}
                </td>
                <td colspan="10" v-else>
                  {{ jwyws(ya.medicineIrritabilityHistory, "medicine") }}
                </td>
              </tr>
            </table>
          </el-form-item>

          <el-row>
            <el-col :span="24">
              <el-form-item label="搜索病症:">
                <el-select style="width:400px" v-model="diseaseValue" multiple remote reserve-keyword
                  :remote-method="remoteMethod" filterable placeholder="搜索病症" @change="diseaseChange">
                  <el-option v-for="item in diseaseList" :key="item.id" :label="item.combinedStr"
                    :value="item.combinedStr">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主要病症:">
                <div v-for="(item, index) in newsList" :key="index" style="margin-bottom: 5px">
                  <el-input disabled v-model="item.preName">
                    <template slot="append">
                      <div style="float: left" class="el-icon-caret-top" @click="moveUp(item, index)"></div>
                      <div style="float: left" class="el-icon-caret-bottom" @click="moveDown(item, index)"></div>
                    </template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="display: flex;justify-content: space-between;">
              <div class="tishi">症状解释请点击帮助（ "<i class="el-icon-question"></i>"为帮助符号）</div>
              <div class="input-inner-btn shou" @click="resetInput()">清空</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <!-- 获得所有的病症{{allBZ}} -->
              <div>
                <el-form-item :label="toChinesNum(index1 + 1) + '级病症:'" v-for="(o, index1) in allBZ" :key="index1"
                  v-if="index1 < 3">
                  <!-- v-if="o.bz.length > 0" -->
                  <div :class="index1 % 2 === 0 ? 'qianBlue' : 'qianPink'" class="paddinglr20">
                    <!-- 选中的病症{{o.checkedBzs}} -->
                    <template>
                      <el-checkbox-group v-model="o.checkedBzs" v-if="index1 === 0">
                        <span v-for="(item, idx) in o.bz" :key="idx">
                          <el-checkbox :label="item.id" :value="item.id" :checked="item.checked"
                            @change="changeVal(item.id, item.disease, idx, index1, o.checkedBzs, o.bz)">
                            {{ item.disease }}
                            <i class="el-icon-question" @click.prevent="tipBox(item)"></i>
                          </el-checkbox>
                        </span>
                      </el-checkbox-group>
                      <el-checkbox-group v-model="o.checkedBzs" v-else>
                        <span v-for="(item, idx) in o.bz" :key="idx">
                          <el-checkbox :label="item.id" :value="item.id" :checked="item.checked"
                            @change="changeVal(item.id, item.disease, idx, index1, o.checkedBzs, o.bz)">
                            {{ item.disease }}
                            <i class="el-icon-question" @click.prevent="tipBox(item)"></i>
                          </el-checkbox>
                        </span>
                      </el-checkbox-group>
                    </template>
                  </div>
                </el-form-item>
                <el-form-item v-if='index1 === 3' :label="toChinesNum(index1 + 1) + '级病症:'" v-for="(o, index1) in allBZ"
                  :key="index1">
                  <div :class="index1 % 2 === 0 ? 'qianBlue' : 'qianPink'" class="paddinglr20">
                    <template>
                      <el-checkbox-group v-model="o.checkedBzs">
                        <span v-for="(item, idx) in o.bz" :key="idx">
                          <el-checkbox :label="item.id" :value="item.id" :checked="item.checked"
                            @change="changeVal(item.id, item.disease, idx, index1, o.checkedBzs, o.bz)">
                            {{
                              item.disease
                            }}<i class="el-icon-question" @click.prevent="tipBox(item)"></i>
                          </el-checkbox>
                        </span>
                      </el-checkbox-group>
                    </template>
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row class="text-center">
            <el-col :span="24">
              <el-form-item>
                <el-button type="danger" @click.native="submitForm('form')" class="btn red">提 交
                </el-button>
                <el-button @click="goBack" class="btn grey">返 回</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 选择最难受的症状 -->
    <el-dialog title="请选择最难受的症状" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :show-close="false"
      width="600px" center class="bodyDialogCenter">
      <el-radio-group v-model="radio" size="small">
        <el-radio :label="item" border v-for="(item, index) in selectLastbz" :key="index">{{ limitMaxWords(5, item) }}
        </el-radio>
      </el-radio-group>

      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="nanshouSubmit" size="small" class="red">确 定
        </el-button>
        <el-button @click="nanshouCancle()" size="small" class="grey">取 消
        </el-button>
      </div>
    </el-dialog>

    <!-- 支付弹框 -->
    <el-dialog title="提示" :visible.sync="zhifuDialog" :close-on-click-modal="false" :show-close="false" center
      width="400px">
      <p class="text-center">
        本次诊断需要支付
        <span class="moneyCss">{{ money }}</span>元费用是否确认支付？
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="fou()" class="grey">否
        </el-button>
        <el-button type="danger" @click="shi()" size="small" class="red">是
        </el-button>
      </div>
    </el-dialog>
    <!-- 支付方式选择 -->
    <el-dialog title="请选择支付方式" :visible.sync="zhifuMethods" :close-on-click-modal="false" :show-close="false" center
      width="400px" class="zhifuMC">
      <el-radio-group v-model="zhifuRadio" @change="selectwxzfb">
        <el-radio label="1">
          <img src="@/assets/list/wei.png" alt class="vertical-middle" />
        </el-radio>
        <el-radio label="2">
          <img src="@/assets/list/zhi.png" alt class="vertical-middle" />
        </el-radio>
      </el-radio-group>
      <!-- 微信支付 -->
      <div id="zzqrcode" v-if="zhifuRadio == '1'"></div>
      <!-- 支付宝支付 -->
      <iframe name="zfbFrom" v-if="zhifuRadio == '2'" class="zfbClass" id="zfbId"></iframe>
      <!-- <iframe v-else class="zfbClass"></iframe> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="zhifuCancle()" class="grey">取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "diagnosis",
  data() {
    return {
      openLoading: false,
      newsList: [],

      //医案信息
      ya: {},
      form: {
        startDate: "",
        selectbzName: ""
      },
      isLast: false, //是不是最后一级
      allBZ: [], //所有级别的病症
      checkedBzsJ: [], //主要病症组成数组
      str: "", //主要病症字符串拼接
      dialogFormVisible: false,
      radio: "", //最难受的病症选择
      selectLastbz: [], //弹框中最后选择的病症
      bzIds: [], //自测接口封装后台需要的病症集合
      continueList: {}, //继续选择病症集合
      dialogFormVisible1: false, //继续选择病症弹框
      continueData: [], //继续选择病症接口
      cradio: "", //继续选择的症状
      zhifuDialog: false, //支付弹框
      money: "", //支付钱数
      archivesId: "", //档案id
      zhifuMethods: false, //支付方式选择
      zhifuRadio: "", //默认微信支付
      htGivebzStr: "",
      paytimer: 300, //300秒，5分钟
      // xwzz: false
      zero: [],
      diseaseValue: [],//病症搜索结果
      diseaseList: [],//病症查询结果
      loading: false,//病症列表加载
      queryList: [],//存储查询后病症数组
      selectList: [],//勾选的病症数组
      level1List: [],//一级列表选中数据
      level2List: [],//二级列表选中数据
      level3List: [],//三级列表选中数据
    };
  },
  // mounted() {
  //     setTimeout(() => {
  //         document.forms[document.forms.length - 1].submit();
  //     }, 1000);
  // },
  methods: {
    // 上移动
    moveUp(item, index) {
      if (index === 0) {
        this.$message({
          message: '到顶了',
          type: 'warning'
        })
      } else {
        let temp = this.newsList[index - 1]
        this.$set(this.newsList, index - 1, this.newsList[index])
        this.$set(this.newsList, index, temp)
      }
    },
    // 下移动
    moveDown(item, index) {
      if (index === (this.newsList.length - 1)) {
        this.$message({
          message: '到低了',
          type: 'warning'
        })
      } else {
        let i = this.newsList[index + 1]
        this.$set(this.newsList, index + 1, this.newsList[index])
        this.$set(this.newsList, index, i)
      }
    },
    changeVal(val, name, index, index1, data, dataBz) {

      this.allBZ[index1].bz[index].checked = !this.allBZ[index1].bz[index].checked;
   
      let that = this;
      if (!this.allBZ[index1].bz[index].checked) {
        if (index1 != that.allBZ.length) {
          that.isLast = false;
        }
        //删除这个选项及选项所在的子集
        const itemId = this.allBZ[index1].bz[index].id;
        // console.log(itemId)
        if (index1 === 0) {
           // 查找并删除当前数据
          const new1 = this.level1List.filter(item => item.id !== itemId);
          this.level1List = new1;
          // 查找并删除 upId 等于 itemId 的元素
          const new2 = this.level2List.filter(item => item.upId !== itemId);
          this.level2List = new2;
          // 查找并删除 oneId 等于 itemId 的元素
          const new3 = this.level2List.filter(item => item.oneId !== itemId);
          this.level3List = new3;
        } else if (index1 === 1) {
            // 查找并删除当前数据
          const new2 = this.level2List.filter(item => item.id !== itemId);
          this.level2List = new2;
            // 查找并删除 twoId 等于 itemId 的元素
          const new3 = this.level3List.filter(item => item.twoId !== itemId);
          this.level3List = new3;
        } else if (index1 === 2) {
           // 查找并删除当前数据
          const new3 = this.level3List.filter(item => item.id !== itemId);
          this.level3List = new3;
        }
        // console.log(this.level1List,'this.level1List')
        // console.log(this.level2List,'this.level2List')
        // console.log(this.level3List,'this.level3List')
        //取消选择,
        that.allBZ.splice(index1 + 1, that.allBZ.length - (index1 + 1)); //该病症级别以下全部删除
        if (!that.isLast) {
           const idArray1 = this.level1List.map(item => item.id);
            const idArray2 = this.level2List.map(item => item.id);
            const idArray3 = this.level3List.map(item => item.id);
            let newArr=[];
            if(index1 === 0) {
              newArr = idArray1;
            }else if(index1 === 1){
              newArr = idArray2;
            }else if(index1 === 2){
               newArr = idArray3;
            }
              console.log(newArr,'newArr')
          // let newArr = this.allBZ[index1].checkedBzs;
          if(newArr.length){
             that.getBZ(that.$route.query.id, newArr, index1);
          }
        }
        // that.checkedBzsJ.splice(index1, that.checkedBzsJ.length - index1); //选择的主要病症删除
        // that.newsList.splice(index1, that.newsList.length - index1); //选择的主要病症删除
        this.selectList = this.filterByLevelAndKeyword(this.selectList, index1, name);
        this.newsList = [...new Set([...this.queryList, ...this.selectList])];
      } else {
        if (index1 === 0) {
          this.level1List.push(this.allBZ[index1].bz[index])
        } else if (index1 === 1) {
          this.level2List.push(this.allBZ[index1].bz[index])
        } else if (index1 === 2) {
          this.level3List.push(this.allBZ[index1].bz[index])
        }
        let newArr=[];
            const idArray1 = this.level1List.map(item => item.id);
            const idArray2 = this.level2List.map(item => item.id);
            const idArray3 = this.level3List.map(item => item.id);
            if(index1 === 0) {
              newArr = idArray1;
            }else if(index1 === 1){
              newArr = idArray2;
            }else if(index1 === 2){
               newArr = idArray3;
            }
        if (!that.isLast) {
          // newArr = this.allBZ[index1].checkedBzs;
          console.log(newArr)
          that.getBZ(that.$route.query.id, newArr, index1);
        }
        this.functional(newArr, index1)
      }
    },


    getCheckedBzIds(allBZ) {
      // 如果 allBZ 为空或不是数组，直接返回空数组
      if (!Array.isArray(allBZ)) {
        return [];
      }

      const result = [];

      allBZ.forEach(group => {
        // 确保 group 有 bz 和 checkedBzs 属性
        const bz = group.bz || [];
        const checkedBzs = group.checkedBzs || [];

        // 如果 checkedBzs 为空数组，跳过处理
        if (checkedBzs.length === 0) {
          return; // 相当于 continue
        }

        // 创建 disease 到 id 的映射，提高查找效率
        const bzMap = new Map();
        bz.forEach(item => {
          if (item && item.disease && item.id) {
            bzMap.set(item.disease, item.id);
          }
        });

        // 遍历 checkedBzs 并收集匹配的 id
        checkedBzs.forEach(checkedDisease => {
          if (bzMap.has(checkedDisease)) {
            result.push(bzMap.get(checkedDisease));
          }
        });
      });

      return result;
    },


    /**
 * 过滤数组中对象的t字段，根据指定层级和关键词进行过滤
 * @param {Array} arr - 原始数组
 * @param {number} level - 要检查的层级(从0开始)
 * @param {string} keyword - 要过滤的关键词
 * @returns {Array} 过滤后的新数组
 */
    filterByLevelAndKeyword(arr, level, keyword) {
      // console.log(arr, level, keyword)
      return arr.filter(item => {
        const parts = item.preName.split('->');
        // 确保该层级存在，且不等于关键词
        return parts.length <= level || parts[level] !== keyword;
      });
    },
    // 查询主要病症
    functional(newArr, index1) {
      let that = this;
      // let lastIndex = that.allBZ.length - 1;
      // let Q = this.allBZ[lastIndex].bz
      // let w = this.allBZ[lastIndex].checkedBzs
      // let newArr = [];
      // for (let i = 0; i < Q.length; i++) {
      //   for (let j = 0; j < w.length; j++) {
      //     if (Q[i].disease === w[j]) {
      //       newArr.push(Q[i].id);
      //     }
      //   }
      // }
      let params = {
        ids: newArr
      };
      let url = "/disease/getPreDisease";
      that.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.selectList = res.data.data;//存储勾选的数组
          this.newsList = [...new Set([...this.queryList, ...this.selectList])];
          if (index1 === 2 || index1 === 3) {
            //   that.newsList = res.data.data
          }
        }
      })
    },
    //获取最小值的下标
    getMinIndex(arr) {
      var min = arr[0];
      //声明了个变量 保存下标值
      var index = 0;
      for (var i = 0; i < arr.length; i++) {
        if (min > arr[i]) {
          min = arr[i];
          index = i;
        }
      }
      return index;
    },
    // 点击问号提示白话文解释
    tipBox(row) {
      // console.log(row, "rowww");
      this.$alert(row.des, "提示", {
        confirmButtonText: "关闭"
        // callback: action => {
        //   this.$message({
        //     type: "info",
        //     message: `action: ${action}`
        //   });
        // }
      });
    },
    // 点击问号提示白话文解释
    tipBoxs(row) {
      this.$alert(row.name_des, "提示", {
        confirmButtonText: "关闭"
        // callback: action => {
        //   this.$message({
        //     type: "info",
        //     message: `action: ${action}`
        //   });
        // }
      });
    },
    //获取医案详情
    async getDetailYiAn(id) {
      let that = this;
      let params = {
        id: id
      };
      let url = "medicalCasesPc/getYaById";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.ya = res.data;
            if (that.ya.childbearingHistory) {
              if (that.ya.childbearingHistory == "5") {
                that.ya.childbearingHistory = "多个";
              }
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //得到病症
    async getBZ(id, val, index) {
      let that = this;
      let params = {
        medId: id,
        ids: val
      };
      let url = "zzPc/v2/chooseBZPc";
      await that.$http.post(url, params).then(res => {
        res = res.data;
        if (res.code == 200) {
          let bzs = res.data.bzs.map(item => ({
            ...item,          // 保留原有属性
            checked: false    // 添加新字段
          }));
          if (res.data.bzs.length > 0) {
            const idArray1 = this.level1List.map(item => item.id);
             const idArray2 = this.level2List.map(item => item.id);
              const idArray3 = this.level3List.map(item => item.id);
             
            if (index === 0 || index === undefined) {
              if (that.allBZ.length > 1) {
                that.allBZ[1].bz = bzs;
              } else {
                   that.allBZ.push({
                      bz: bzs,
                      checkedBzs: []
                    });
              }
            } else if (index === 1) {
              let i = that.allBZ.length
              if (i === 2) {
                that.allBZ.push({
                  bz: bzs,
                  checkedBzs: []
                });
              } else {
                that.allBZ[index + 1].bz = bzs
              }
            } else if (index === 2) {
              let i = that.allBZ.length
              if (i === 3) {
                that.allBZ.push({
                  bz: bzs,
                  checkedBzs: []
                });
              } else {
                that.allBZ[index + 1].bz = bzs
              }
            } 
            else if (index === 3) {
              let i = that.allBZ.length
              if (i === 4) {
                that.allBZ.push({
                  bz: bzs,
                  checkedBzs: []
                });
              } else {
                that.allBZ[index + 1].bz = bzs
              }
            }
            that.allBZ[0].checkedBzs = idArray1;
             that.allBZ[1].checkedBzs = idArray2;
             that.allBZ[2].checkedBzs = idArray3;
            that.isLast = res.data.isLast;
          } else {
            that.isLast = res.data.isLast;
          }
        } else {
          that.$message.error(res.msg);
        }
      })
    },
    //清空选择的病症
    resetInput() {
      let that = this;
      that.isLast = false;
      this.selectList = []
      that.checkedBzsJ = []; //主要病症清空
      that.allBZ.splice(1, that.allBZ.length - 1); //该病症级别以下全部删除
      that.allBZ[0].checkedBzs.splice(0, that.allBZ[0].checkedBzs.length); //一级病症清空选中的
      that.bzIds = []; //清空自测提交接口选择的病症
    },
    // 取消
    goBack() {
      this.$confirm("此操作将不保存该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {
        });
    },
    //最难受的症状选择
    nanshouSubmit() {
      let that = this;
      if (!that.radio) {
        that.$message({
          type: "warning",
          message: "请您选择一个最难受的症状"
        });
        return false;
      }
      that.bzIds = [];
      for (const item of that.selectLastbz) {
        if (that.radio == item) {
          that.bzIds.push(item);
        } else {
          that.bzIds.push(item);
        }
      }
      that.submitForm("form");
    }, //自测提交
    //a为是否为第一次诊断
    //b为再次选择的症状
    submitForm(formName, a, b) {
      let that = this;
      that.$refs[formName].validate(async valid => {
        if (!valid) return;
        if (that.allBZ[that.allBZ.length - 1].checkedBzs.length > 0 || this.queryList.length) {
          //证明选择了最后一级
          // that.selectLastbz = that.allBZ[that.allBZ.length - 1].checkedBzs;
          // if (!a == 1) {
          //   if (that.selectLastbz.length == 1) {
          //     that.bzIds.pop();
          //     that.bzIds.push(that.selectLastbz[0]);
          //   }
          // }
          // // 新增 提交把选中的参数放进 bzIds 里面
          // for (const item of that.selectLastbz) {
          //   that.bzIds.push(item);
          // }

          // if (that.bzIds.length > 0) {
          //   let bzStr = "";
          //   for (let i = 0; i < that.checkedBzsJ.length; i++) {
          //     if (i == that.checkedBzsJ.length - 1) {
          //       bzStr += that.checkedBzsJ[i];
          //     } else {
          //       bzStr += that.checkedBzsJ[i] + "-";
          //     }
          //   }
          //   if (b) {
          //     that.bzIds.push(b)
          //   }
          //   var str = "";
          //   that.allBZ.forEach((item, index) => {
          //     if (index === 0) {
          //       str = '「' + item.checkedBzs + '」' + ' → '
          //     } else {
          //       let lastIndex = that.allBZ.length - 1
          //       if (lastIndex === index) {
          //         let arr = item.checkedBzs.map(i => {
          //           return '(' + i + ')'
          //         })
          //         str += arr.join('、') + ' →'
          //       } else {
          //         str += item.checkedBzs.join('、') + ' →'
          //       }
          //     }
          //   })
          // 1. 构建层级结构：{ 一级分类: { 二级分类: Set(症状) } }
          const hierarchy = {};

          this.newsList.forEach(({ preName }) => {
            const [level1, level2, ...symptoms] = preName.split("->");

            if (!hierarchy[level1]) {
              hierarchy[level1] = {};
            }
            if (!hierarchy[level1][level2]) {
              hierarchy[level1][level2] = new Set();
            }

            symptoms.forEach(symptom => {
              hierarchy[level1][level2].add(symptom);
            });
          });

          // 2. 格式化输出
          const result = Object.entries(hierarchy).map(([level1, subLevels]) => {
            const subLevelStr = Object.entries(subLevels).map(([level2, symptoms]) => {
              const symptomStr = [...symptoms].map(s => `(${s})`).join("，");
              return `${level2} →${symptomStr}`;
            }).join("、");

            return `「${level1}」→ ${subLevelStr}`;
          }).join("；");

          // console.log(result);
          let bzs = [];
          let diseaseDes = this.newsList.map(item => {
            const parts = item.preName.split('->');
            bzs.push(parts[2]);
            const tit = parts[0];
            const val = parts.slice(1).join('->');
            return {
              preName: item.preName,
              id: item.id,
              tit: tit,
              val: val
            };
          });

          let url = "zzPc/v2/zzLogicalPc";
          let params = {
            bzs: bzs,
            process: result,
            diseaseTime: that.form.startDate,
            medId: that.$route.query.id,
            bzStr: result,
            isFirst: that.$route.query.firstArchivesId ? false : true,
            firstArchivesId: that.$route.query.firstArchivesId ? that.$route.query.firstArchivesId : null,
            diseaseDes: JSON.stringify(diseaseDes)
          };
          that.$http.post(url, params).then(res => {
            that.cradio = "";
            res = res.data;
            that.dialogFormVisible = false;
            this.openLoading = false;
            if (res.code == 200) {
              if (!!res.data.money) {
                //需要支付
                that.money = res.data.money;
              } else if (res.data.money == 0) {
                that.money = res.data.money;
              }
              // that.zhifuDialog = true;


              if (res.data.archivesId) {
                that.archivesId = res.data.archivesId;
                that.payZero(that.archivesId);
              }
            } else if (res.code == 41005) {
              // that.htGivebzStr = res.data.bzStr;
              that.bzStr = res.data.bzStr;
              that.continueList = res.data.jjBz;
              that.change(that.continueList);
            } else {
              // that.xwzz = true;
              that.$message.error(res.msg);
              that.radio = "";
            }
          }).catch(() => {
          });
          // }
        } else {
          that.$message({
            type: "warning",
            message: "请您将病症选择到最后一级再提交！"
          });
        }
      });
    },
    // 症状10层判断
    change(arr) {
      let that = this;
      if (arr.one.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.bzinfos;
        arr.one = [];
      } else if (arr.two.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.two;
        arr.two = [];
      } else if (arr.three.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.three;
        arr.three = [];
      } else if (arr.four.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.four;
        arr.four = [];
      } else if (arr.five.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.five;
        arr.five = [];
      } else if (arr.six.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.six;
        arr.six = [];
      } else if (arr.serven.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.serven;
        arr.serven = [];
      } else if (arr.eight.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.eight;
        arr.right = [];
      } else if (arr.nine.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.nine;
        arr.nine = [];
      } else if (arr.ten.length > 0) {
        that.dialogFormVisible1 = true;
        that.continueData = arr.ten;
        arr.ten = [];
      } else {
        that.dialogFormVisible1 = false;
        that.$message({
          type: "warning",
          message: "没有病症，请重新选择"
        });
      }
    },
    //以上都不是
    allNo() {
      let that = this;
      that.selectLastbz = [];
      that.radio = "";
      that.cradio = "";
      that.change(that.continueList);
    },
    // 选择一个病症的确定
    selectBZsubmit() {
      let that = this;
      let bzIdsList = that.bzIds.slice();
      that.bzIds = [];
      // if (that.cradio) {
      //   that.bzIds.push(bzIdsList[bzIdsList.length - 1]);
      // } else {
      //   that.bzIds.push(bzIdsList[bzIdsList.length - 2]);
      // }
      if (that.cradio) {
        // that.bzIds.push(that.cradio);
        // that.bzIds.push({
        //   bz_name: that.cradio,
        //   isSelect: false
        // });
        this.openLoading = true;
        that.submitForm("form", 1, that.cradio.name);
      } else {
        that.$message({
          type: "warning",
          message: "请您选择一个症状"
        });
      }
    },
    // 支付否
    fou() {
      this.zhifuDialog = false;
      this.dialogFormVisible1 = false;
      this.radio = "";
      this.bzIds = []
    },
    // 支付是
    shi() {
      let that = this;
      that.dialogFormVisible1 = false;
      that.zhifuDialog = false;
      if (!!that.money) {
        that.zhifuMethods = true;
      } else {
        //第一次0元不需要支付
        that.dialogFormVisible1 = false;
        that.payZero(that.archivesId);
      }
    },
    // 选择支付方式
    zhifuSelect() {
      let that = this;
      if (!that.zhifuRadio) {
        that.$message({
          message: "请您选择支付方式",
          type: "warning"
        });
        return false;
      }
      // if (that.zhifuRadio) {
      //     that.$message({
      //         type: "warning",
      //         message: "请您扫码支付"
      //     });
      //     return false;
      // }
      let params = {
        id: that.archivesId,
        zzfs: that.zhifuRadio,
        money: that.money
      };
      let url = "zzPay/zzPayOrder";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          if (that.zhifuRadio == "1") {
            // that.zhifuButton = false;
            document.getElementById("zzqrcode").innerHTML = "";
            //微信支付
            new QRCode(
              document.getElementById("zzqrcode"),
              res.data.data.codeUrl
            ); // 设置要生成二维码的链接
          } else {
            //支付宝支付
            const div = document.createElement("div");
            div.innerHTML = res.data.data.orderStr; // 接口返回的form 表单字符串
            document.body.appendChild(div);
            // document.forms[4].acceptCharset = "UTF-8"; //如果后台返回form的charset=GBK，需要做此修改
            document.forms[document.forms.length - 1].submit();
          }
          that.getPayStatus();
        }
      });
    },
    //选择微信支付还是支付宝支付
    selectwxzfb(val) {
      this.zhifuSelect();
    },
    //最难受的症状取消
    nanshouCancle() {
      let that = this;
      that.dialogFormVisible = false;
      that.radio = "";
      that.cradio = "";
    },
    //支付取消
    zhifuCancle() {
      let that = this;
      that.zhifuMethods = false;
      that.radio = "";
      that.cradio = "";
      that.payFinish = true;
    },
    // 判断是否支付成功的回调
    getPayStatus() {
      let that = this;
      let payFinish = false;
      if (that.paytimer == 0) {
        that.$message.error("您在五分钟之内未支付，请支付");
        that.paytimer = 300;
        return false;
      }
      if (payFinish) return false;
      let url = "/zzPay/zfType";
      let params = new URLSearchParams();
      params.append("id", that.archivesId);
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.paytimer = that.paytimer - 5;
            if (res.data == "0") {
              // 未付款
              if (that.zhifuMethods) {
                setTimeout(that.getPayStatus, 5000);
              }
              // console.log(that.paytimer);
            } else if (res.data == "1") {
              //已付款
              payFinish = true;
              that.$message({
                message: "支付成功",
                type: "success"
              });
              that.$router.push({
                path: "/recResults",
                query: {
                  id: that.archivesId,
                  medId: that.$route.query.id,
                  name: "1"
                }
              });
            } else {
              //失败
              payFinish = true;
              that.zhifuMethods = false;
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //支付0元，后台去更改状态
    payZero(id) {
      let that = this;
      let params = new URLSearchParams();
      params.append("id", id);
      let url = "/medicalCasesPc/updateArchivesIsPay";
      that.$http
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            that.$router.push({
              path: "/recResults",
              query: {
                id: id,
                medId: that.$route.query.id,
                name: "1"
              }
            });
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
        });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        let that = this;
        let params = {};
        params.disease = query;
        params.medId = that.$route.query.id;
        let url = "/zzPc/chooseBzByName";
        that.$http
          .post(url, params)
          .then(res => {
            if (res.data.code == 200) {
              this.loading = false;
              let array = res.data.data;
              // 遍历数组，拼接并添加新字段
              this.diseaseList = array.map(obj => {
                // 拼接三个字符串
                const newField = `${obj.oneDisease}->${obj.twoDisease}->${obj.disease}`;
                // 返回新对象（包含原对象的所有属性 + 新字段）
                return {
                  ...obj,          // 展开原对象的所有属性
                  combinedStr: newField  // 添加新字段
                };
              });
            } else {
              this.loading = false;
              this.diseaseList = [];
              that.$message.error(res.data.msg);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.diseaseList = [];
      }
    },
    diseaseChange(e) {
      this.queryList = e.map(item => ({ preName: item }));;//存储勾选的数组
      this.newsList = [...new Set([...this.queryList, ...this.selectList])];
      // console.log(this.newsList)
    }
  },

  created() {
    let that = this;
    if (!!that.$route.query.id) {
      that.getDetailYiAn(
        that.$route.query.id,
        that.$route.query.firstArchivesId,
      );
      that.getBZ(that.$route.query.id);
    }
  }
};
</script>

<style scoped>
.input-inner-btn {
  width: 46px;
  display: block;
  height: 22px;
  line-height: 22px;
  background-color: #f64420;
  color: white;
  text-align: center;
  margin-right: 11px;
  /*position: absolute;*/
  /*top: 10px;*/
  /*right: 0px;*/
}

.paddinglr20 {
  padding: 0px 20px;
  border: solid 1px #dddddd;
}

.el-checkbox {
  margin-right: 30px;
}

/* .setWidth {
    min-width: 100px;
    max-width: 100px;
    display: inline-block;
} */
.el-radio--small.is-bordered {
  width: 100px;
  margin-bottom: 10px;
  margin-left: 10px;
}

.moneyCss {
  color: red;
  font-size: 24px;
}

.zfbClass {
  border: none;
  height: 80px;
  margin: 30px 0px 0px 90px;
}
</style>
<style>
.zfbClass html {
  background: none !important;
}

.zhifuMC .el-dialog--center .el-dialog__body {
  text-align: center !important;
  overflow: hidden;
}

#zzqrcode {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  padding-top: 30px;
}

#zzqrcode img {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}

.orange {
  color: orange;
}

.bodyDialogCenter .el-dialog--center .el-dialog__body {
  text-align: center;
}

.tishi {
  color: red;
  margin-bottom: 22px;
  display: inline-block;
  margin-left: 16px;
}

/*[class*=" el-icon-"], [class^=el-icon-] {*/
/*  float: right;*/
/*}*/
.bj {
  background-color: #f64420 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/JW/diagnosis.vue